export default __webpack_public_path__ + "static/media/blue-landing.b0412c43.webp";